
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor02On as ObiCapacitor02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-02-on.js';
 
 
 

 
 export const ObiCapacitor02On = createComponent({
   react: React,
   tagName: 'obi-capacitor-02-on',
   elementClass: ObiCapacitor02OnElement,
   events: {
     
   }
  });
 
 